module.exports = __webpack_public_path__ + "media/images/about-us/media1-8f497a34d085b5650c59ca673d62f0cc.png";